import EFTFlow from "@/components/Exercises/EFT/EFTFlow";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import { Button } from "@/components/ui/button";
import { isAdultExerciseGroup } from "@/lib/data/contentCatalog";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/eft/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [{ title: "Emotional Freedom Technique - HAMD" }],
  }),
  beforeLoad: () => ({
    title: "eft.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const { referrer, referrerGroup } = Route.useSearch();
  const navigate = useNavigate();
  const [showExercise, setShowExercise] = useState(false);

  const handleComplete = () => {
    setShowExercise(false);
    if (referrer) {
      const group = isAdultExerciseGroup(referrerGroup) ? referrerGroup : undefined;
      navigate({
        to: `/adults/exercises/${referrer}` as "/",
        search: group ? { mode: "exercises", group } : undefined,
      });
    }
  };

  const handleExit = () => {
    setShowExercise(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={() => setShowExercise(true)}>
          <FormattedMessage id="common.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="eft.intro" />
      </p>

      <EFTFlow
        isShow={showExercise}
        onComplete={handleComplete}
        onExit={handleExit}
      />
    </ExerciseLayout>
  );
}
